import type {
    BoardColumnDef,
    BoardLaneDef,
    BoardPlacement,
} from "./Board.types";
import { createBoardCollapse, getExpandedIds } from "./boardCollapse";
import { isExpanded } from "./boardNavigation";

interface BoardVisibilityArgs {
    columns: readonly BoardColumnDef[];
    lanes?: readonly BoardLaneDef[];
    collapsedColumnIds?: readonly string[];
    collapsedLaneIds?: readonly string[];
}

/**
 * Whether a board given these props shows a card at a placement: its column
 * and lane are on the board and expanded (the null lane only on a board
 * without lanes). The same rule the board's keyboard focus follows; prune
 * `selectedItemIds` with it.
 */
export const createIsPlacementShown = ({
    columns,
    lanes,
    collapsedColumnIds,
    collapsedLaneIds,
}: BoardVisibilityArgs) => {
    const expanded = getExpandedIds({
        columns,
        lanes,
        collapse: createBoardCollapse({ collapsedColumnIds, collapsedLaneIds }),
    });
    return (placement: BoardPlacement) => isExpanded(expanded, placement);
};
